import {
  roleTypes,
  activityTypes,
  genderTypes,
  raceTypes,
  companyRoleTypes,
  companyActivityTypes,
  companyIndustryTypes,
  companyDepartmentTypes,
  companyDiverseType,
  companyVerificationTypes,
} from "./options"
import { getMarketDisplayName } from "../../../../components/CompanyUserInfo/options/marketOptions"

const getOptionName = (options, selectedType) => {
  const selectedOption = options.find((option) => option.type === selectedType)
  return selectedOption?.title
}
export const getRoleTypeName = (type) => getOptionName(roleTypes, type)
export const getActivityTypeName = (type) => getOptionName(activityTypes, type)
export const getGenderTypeName = (type) => getOptionName(genderTypes, type)
export const getRaceTypeName = (type) => getOptionName(raceTypes, type)
export const getCompanyRoleTypeName = (type) =>
  getOptionName(companyRoleTypes, type)
export const getCompanyActivityTypeName = (type) =>
  getOptionName(companyActivityTypes, type)
export const getCompanyIndustryTypeName = (type) =>
  getOptionName(companyIndustryTypes, type)
export const getCompanyDepartmentTypeName = (type) =>
  getOptionName(companyDepartmentTypes, type)
export const getCompanyDiverseTypeName = (type) =>
  getOptionName(companyDiverseType, type)
export const getCompanyVerificationTypeName = (type) =>
  getOptionName(companyVerificationTypes, type)
export const getCompanyClassificationList = (classifications) => {
  let classificationList = []
  if (classifications && typeof classifications === "string") {
    classificationList = classifications.split(",")
  } else if (classifications?.length) {
    classificationList = classifications
  }
  return classificationList
}
export const getCompanyMarketName = getMarketDisplayName
